interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label: string;
}

export function TextArea({ label, ...props }: TextAreaProps) {
	return (
		<label>
			<div data-type-style="label" className="font-black">
				{label}
			</div>
			<textarea
				rows={4}
				{...props}
				className="focus:green-600 mt-2 block w-full rounded-lg border border-gray-300 p-2.5 text-base text-gray-800 focus:outline-green-600"
			/>
		</label>
	);
}
